import {WarehouseLogin} from 'constants/WarehouseConstants';
import * as net from 'util/Net';

interface WarehouseLogins {
  logins: Array<WarehouseLogin>;
}

export interface CreateUserDefinedViewRequest {
  view_name: string;
  view_sql: string;
  view_description: string;
}

export interface CreateUserDefinedViewResponse {}

export function fetchLogins(): Promise<WarehouseLogins> {
  return Promise.resolve(net.getJSON('/1/api/warehouse/logins'));
}

export function createLogin(label: string): Promise<WarehouseLogin> {
  return Promise.resolve(
    net.postJSON({
      url: '/1/api/warehouse/logins',
      data: {label},
    })
  );
}

export function revokeLogin(login: WarehouseLogin): Promise<WarehouseLogin> {
  return Promise.resolve(net.delete_({url: `/1/api/warehouse/logins/${login.id}`}));
}

export function createUserDefinedView(
  data: CreateUserDefinedViewRequest
): Promise<CreateUserDefinedViewResponse> {
  return net.postJSONPromise({
    url: '/1/api/warehouse/user-defined-views',
    data,
  });
}
